import poly from "assets/images/chainlogos/poly.png";
import binance from "assets/images/chainlogos/bn.png";
import ether from "assets/images/chainlogos/Ether.png";
import { NFT_ATTRIBUTES } from "common/type";
import { mainnet, sepolia, polygon, polygonAmoy, bsc, bscTestnet } from 'wagmi/chains';
import { Address } from "viem";

export const SERVER_BASE_URL =
	process.env.REACT_APP_API_BASE_URL || "https://api-qa.onrekord.app";

export const API_BASE_URL = SERVER_BASE_URL + "/api";

export const MARKETPLACE_URL = process.env.REACT_APP_MARKETPLACE_URL || "https://marketplace.onrekord.io";

export const CKEDITOR_LICENSE_KEY = process.env.REACT_APP_CKEDITOR_LICENSE_KEY || "";

export const LIGHTHOUSE_API_KEY = process.env.REACT_APP_LIGHTHOUSE_API_KEY || "";
export const LIGHTHOUSE_API_URL = process.env.REACT_APP_LIGHTHOUSE_API_URL || "";

export const ONREKORD_APP_URL = process.env.REACT_APP_ONREKORD_APP_URL || "https://nft-qa.onrekord.io";

export const OR_APP_ENV = process.env.REACT_APP_OR_APP_ENV || "qa";

export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "";

export const ONREKORD_WHITE_GLOVE_WALLETS: string[] = [
  "0x0DAd9ACcE66371072cED21FCBF7941F8df5b3cb1",
  "0x6Fb798531a7C38158CC1F82EBd8bc835d5f3FAb7",
  "0x3eA3D8432baC9A756ACDf6B11845e845806494F8",
	"0x58e274F23ca250c0D0486E28e3300aA2B7526ea8",
	"0x5c29cd8bD282cf469AEe5A81A779519d309BB00C",
	"0x53990f1Fa8bf153e63b9D9b11e50A93346dDdbFc",
	"0x24E440E2F0516B3C787AB69f1c37BBc825caBd1D",
	"0xcd6e44377cB72e8bD1A8a42E425A77330e29Ecdc",
	"0xe7a9bda1eaf307f51008cce34016aead6bb92795",
	"0xf2004F388E83C30BD697e450eE57e66E3E71C901",
	"0xa091573829C15D865670F726a0E38f2E76850808", // Tom McNalley's OnRekord account
	"0x263D70a38351e5dE520c626FE8c5ccAc3DCcF12d",
	"0x14983E8199045907351494675c77616aD476B6A8"
];

export const KYC_TOKEN_ADDRESS = "0x6e0FF10f4207f945E1892D9ca2B6B5C0A952efAE";
export const NFT_CONTRACT_ADDRESS =
	"0x0E0CfbBc44D6B05D74435B7b1f38190A611876B1";

export const KWIK_TRUST_WALLET_ADDRESS =
	"0x1D635535040Defd0767Fa062a9fBdF004dca5D6a";

export const ZERO_HASH = '0x0000000000000000000000000000000000000000000000000000000000000000';

export const PINATA_JWT_TOKEN =
	"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySW5mb3JtYXRpb24iOnsiaWQiOiI5ZmIyNGRlYy03MmYzLTQyNmQtOTFjOS01YWEyNzlkMjNlNWYiLCJlbWFpbCI6ImFyZmFuQGt3aWt0cnVzdC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwicGluX3BvbGljeSI6eyJyZWdpb25zIjpbeyJkZXNpcmVkUmVwbGljYXRpb25Db3VudCI6MSwiaWQiOiJGUkExIn0seyJkZXNpcmVkUmVwbGljYXRpb25Db3VudCI6MSwiaWQiOiJOWUMxIn1dLCJ2ZXJzaW9uIjoxfSwibWZhX2VuYWJsZWQiOmZhbHNlLCJzdGF0dXMiOiJBQ1RJVkUifSwiYXV0aGVudGljYXRpb25UeXBlIjoic2NvcGVkS2V5Iiwic2NvcGVkS2V5S2V5IjoiZDc2ZDFlYjJhNTUwMmQ3MjA5MDAiLCJzY29wZWRLZXlTZWNyZXQiOiIyNmE4MTMwNzlkMTY4ZWZhYmE2NzA1MzFkMGUxOGUyNGQ0NDgxYTY0OGNlODgwZGFjMmYzMTk0NTBmZGZmMDYwIiwiZXhwIjoxNzY5OTM3ODkxfQ.I9hMOP_u08cqs0YvDG_iBBNc3TwP-C4g6vzrgSmFlc0";
export const COST_PER_IDENTITY_CHECK_KTX = 20;
// export const COST_PER_IDENTITY_CHECK_KTX = 0.1;
export const COST_PER_MINT = 1;
// export const COST_PER_MINT = 0.001;

export const KYC_STATUS = {
	CLEAR: "clear",
	pending: "pending",
	rejected: "rejected",
	FAILED: "failed",
	ABANDONED: "abandoned",
};

export type KycStatus = typeof KYC_STATUS[keyof typeof KYC_STATUS];

export const ROLES = {
	DEFAULT: "DEFAULT",
	ADMIN: "ADMIN",
};

export const NFT_STATUS = {
	DRAFT: "Draft",
	MINTED: "Minted",
};

export const REVENUE_STATUS = {
	PENDING: "PENDING",
	VALIDATED: "VALIDATED",
	EXPIRED: "EXPIRED",
	REJECTED: "REJECTED",
};

export const BLOG_STATUS = [
  { id: 'draft', name: 'Draft' },
  { id: 'published', name: 'Published' },
];

export const IMAGE_FILE_INPUTS: any = {
	coverImage: "image",
	profile_pic: "image",
};

export const NFT_FIELDS: NFT_ATTRIBUTES = {
	title: "Title",
	artist_name: "Artist/Band Name",
	artist_legal_name: "Artist Legal Name",
	artist_prs_no: "Artist Collection Society Number",
	tags: "Rekord Assets tags",
	description: "Asset Description",
	"asset.url": "Main Asset File",
	"coverImage.url": "Cover Image",
	"contributorRole.name": "Roles",
};

export const SUPPORTED_CHAINS = [
	{
		chain: "Metamask",
		logo: "meta",
	},
];

export enum I18nCommandEnum {
	// * 언어 종류
	KO = "ko",
	EN = "en",

	// * Auth 종류
	SIGN_IN = "sign_in",
	SIGN_OUT = "sign_out",
	SIGN_UP = "sign_up",

	// * Common
	CREATE = "create",
	MODIFY = "modify",
	SEARCH = "search",
	SEARCH_NOTE = "search_note",

	// * User Model
	ROLE = "role",
	EMAIL = "email",
	NICKNAME = "nickname",
	PASSWORD = "password",
	CONFIRM_PASSWORD = "confirm_password",

	// * Contents Model
	CONTENTS_TITLE = "contents_title",
	CONTENTS_SUB_TITLE = "contents_sub_title",
	CONTENTS_DESC = "contents_desc",
	CONTENTS_IMAGE = "contents_image",

	// * Design Model
	DESIGN_ID = "design_id",
	DESIGN_NAME = "design_name",

	// * User Model - Button
	UPDATE_USER_INFO = "update_user_info",
	DELETE_ACCOUNT = "delete_account",

	// * Tab
	DASHBOARD = "dashboard",
	USER_LIST = "user_list",
	CONTENTS_LIST = "contents_list",
	DESIGN_LIST = "design_list",
}

interface NETWORKSOBJType {
	[key: string]: {
		id: number;
		name: string;
		symbol: string;
		blockExplorerUrl: string;
		icon: string;
		logo: string;
		testnet: boolean;
		contractAddress: Address;
		onRekordCollectionAddress: Address;
		rpcUrl: {
			https: string;
			wss: string;
		};
		nameInCoingecko: string;
		currencyTokens: any;
	};
}

export const NETWORKS: NETWORKSOBJType = {
	// 1: {
	// 	id: 1,
	// 	name: "Ethereum - Mainnet",
	// 	symbol: "ETH",
	// 	blockExplorerUrl: "https://etherscan.io/",
	// 	icon: new URL(`${ether}`, import.meta.url).href,
	// 	// icon: import(`../assets/eterscan.png`),
	// 	logo: new URL(`${ether}`, import.meta.url).href,
	// 	rpcUrl: {
	// 		https: ``,
	// 		wss: "",
	// 	},
	// 	nameInCoingecko: "ethereum",
	// 	currencyTokens: {
	// 		// Note: addresses must be in lowerCase
	// 		"0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48": {
	// 			id: "USDC",
	// 			address: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
	// 			symbol: "USDC",
	// 			image: {
	// 				thumb:
	// 					"https://assets.coingecko.com/coins/images/6319/thumb/USD_Coin_icon.png?1547042389",
	// 				small:
	// 					"https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
	// 				large:
	// 					"https://assets.coingecko.com/coins/images/6319/large/USD_Coin_icon.png?1547042389",
	// 			},
	// 		},
	// 		"0xdac17f958d2ee523a2206206994597c13d831ec7": {
	// 			id: "USDT",
	// 			address: "0xdac17f958d2ee523a2206206994597c13d831ec7",
	// 			symbol: "USDT",
	// 			image: {
	// 				thumb:
	// 					"https://assets.coingecko.com/coins/images/325/thumb/Tether.png?1668148663",
	// 				small:
	// 					"https://assets.coingecko.com/coins/images/325/small/Tether.png?1668148663",
	// 				large:
	// 					"https://assets.coingecko.com/coins/images/325/large/Tether.png?1668148663",
	// 			},
	// 		},
	// 		"0x0000000000000000000000000000000000000000": {
	// 			id: "ethereum",
	// 			address: "0x0000000000000000000000000000000000000000",
	// 			symbol: "ETH",
	// 			image: {
	// 				thumb:
	// 					"https://assets.coingecko.com/coins/images/279/thumb/ethereum.png?1595348880",
	// 				small:
	// 					"https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880",
	// 				large:
	// 					"https://assets.coingecko.com/coins/images/279/large/ethereum.png?1595348880",
	// 			},
	// 		},
	// 	},
	// },
	11155111: {
		id: 11155111,
		name: "Sepolia Testnet",
		symbol: "ETH",
		blockExplorerUrl: "https://sepolia.etherscan.io/",
		icon: new URL(`${ether}`, import.meta.url).href,
		// icon: import(`../assets/eterscan.png`),
		logo: new URL(`${ether}`, import.meta.url).href,
		testnet: true,
		contractAddress: "0x1534a806248f4fE5E764A49fB2290B0f44d4AadC",
		onRekordCollectionAddress: "0x96f69EFCB0B4A946cc412c1CF28B89cf040Aefd0",
		rpcUrl: {
			https: "",
			wss: "",
		},
		nameInCoingecko: "ethereum",
		currencyTokens: {
			// Note: addresses must be in lowerCase
			"0x779877a7b0d9e8603169ddbd7836e478b4624789": {
				id: "chainlink",
				address: "0x779877a7b0d9e8603169ddbd7836e478b4624789",
				symbol: "LINK",
				image: {
					thumb:
						"https://assets.coingecko.com/coins/images/877/thumb/chainlink-new-logo.png?1547034700",
					large:
						"https://assets.coingecko.com/coins/images/877/large/chainlink-new-logo.png?1547034700",
				},
			},
		},
	},

	137: {
		id: 137,
		name: "Polygon - Mainnet",
		symbol: "MATIC",
		blockExplorerUrl: "https://polygonscan.com/",
		icon: new URL(`${poly}`, import.meta.url).href, // TODO:change icon & logo
		rpcUrl: {
			https: ``,
			wss: "",
		},
		testnet: false,
		logo: new URL(`${poly}`, import.meta.url).href,
		nameInCoingecko: "polygon-pos",
		contractAddress: "0x851e20EF0a9bd6afD8198d7eBfCeEaAf2D06Edc3",
		onRekordCollectionAddress: "0xC9029f6ce98CE52F9b4049de8F98514b63cEbD93",
		currencyTokens: {
			// Note: addresses must be in lowerCase
			"0x3c499c542cef5e3811e1192ce70d8cc03d5c3359": {
				id: "usdc",
				address: "0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359",
				symbol: "USDC",
				image: {
					thumb:
						"https://assets.coingecko.com/coins/images/14692/thumb/lokr.png?1648886932",
					small:
						"https://assets.coingecko.com/coins/images/14692/small/lokr.png?1648886932",
					large:
						"https://assets.coingecko.com/coins/images/14692/large/lokr.png?1648886932",
				},
			},
			// 	"0x2791bca1f2de4661ed88a30c99a7a9449aa84174": {
			// 		id: "USDC",
			// 		address: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
			// 		symbol: "USDC",
			// 		image: {
			// 			thumb:
			// 				"https://assets.coingecko.com/coins/images/6319/thumb/USD_Coin_icon.png?1547042389",
			// 			small:
			// 				"https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
			// 			large:
			// 				"https://assets.coingecko.com/coins/images/6319/large/USD_Coin_icon.png?1547042389",
			// 		},
			// 	},
			// 	"0xc2132d05d31c914a87c6611c10748aeb04b58e8f": {
			// 		id: "USDT",
			// 		address: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
			// 		symbol: "USDT",
			// 		image: {
			// 			thumb:
			// 				"https://assets.coingecko.com/coins/images/325/thumb/Tether.png?1668148663",
			// 			small:
			// 				"https://assets.coingecko.com/coins/images/325/small/Tether.png?1668148663",
			// 			large:
			// 				"https://assets.coingecko.com/coins/images/325/large/Tether.png?1668148663",
			// 		},
			// 	},
			// 	"0x0000000000000000000000000000000000000000": {
			// 		id: "matic-network",
			// 		address: "0x0000000000000000000000000000000000000000",
			// 		symbol: "MATIC",
			// 		image: {
			// 			thumb:
			// 				"https://assets.coingecko.com/coins/images/4713/thumb/matic-token-icon.png?1624446912",
			// 			small:
			// 				"https://assets.coingecko.com/coins/images/4713/small/matic-token-icon.png?1624446912",
			// 			large:
			// 				"https://assets.coingecko.com/coins/images/4713/large/matic-token-icon.png?1624446912",
			// 		},
			// 	},
			// },
		},
		// 80001: {
		// 	id: 80001,
		// 	name: "Polygon Testnet",
		// 	symbol: "MATIC",
		// 	blockExplorerUrl: "https://mumbai.polygonscan.com/",
		// 	icon: new URL(`${poly}`, import.meta.url).href, // TODO:change icon & logo
		// 	testnet: true,
		// 	rpcUrl: {
		// 		https: "https://rpc-mumbai.maticvigil.com",
		// 		wss: "",
		// 	},
		// 	logo: new URL(`${poly}`, import.meta.url).href,
		// 	nameInCoingecko: "polygon-pos",
		// 	currencyTokens: {
		// Note: addresses must be in lowerCase
		// "0x326c977e6efc84e512bb9c30f76e30c160ed06fb": {
		// 	id: "chainlink",
		// 	address: "0x326c977e6efc84e512bb9c30f76e30c160ed06fb",
		// 	symbol: "LINK",
		// 	image: {
		// 		thumb:
		// 			"https://assets.coingecko.com/coins/images/877/thumb/chainlink-new-logo.png?1547034700",
		// 		small:
		// 			"https://assets.coingecko.com/coins/images/877/small/chainlink-new-logo.png?1547034700",
		// 		large:
		// 			"https://assets.coingecko.com/coins/images/877/large/chainlink-new-logo.png?1547034700",
		// 	},
		// },
		// "0x60e6895184448f3e8ef509d083e3cc3ac31f82fd": {
		// 	id: "ktx",
		// 	address: "0x60e6895184448f3e8ef509d083e3cc3ac31f82fd",
		// 	symbol: "KTX",
		// 	image: {
		// 		thumb:
		// 			"https://assets.coingecko.com/coins/images/14692/thumb/lokr.png?1648886932",
		// 		small:
		// 			"https://assets.coingecko.com/coins/images/14692/small/lokr.png?1648886932",
		// 		large:
		// 			"https://assets.coingecko.com/coins/images/14692/large/lokr.png?1648886932",
		// 	},
		// },
		// "0x0000000000000000000000000000000000000000": {
		// 	id: "matic-network",
		// 	address: "0x0000000000000000000000000000000000000000",
		// 	symbol: "MATIC",
		// 	image: {
		// 		thumb:
		// 			"https://assets.coingecko.com/coins/images/4713/thumb/matic-token-icon.png?1624446912",
		// 		small:
		// 			"https://assets.coingecko.com/coins/images/4713/small/matic-token-icon.png?1624446912",
		// 		large:
		// 			"https://assets.coingecko.com/coins/images/4713/large/matic-token-icon.png?1624446912",
		// 	},
		// },
		// },
	},

	80002: {  
		id: 80002,  
		name: "Polygon Amoy Testnet",  
		symbol: "MATIC",  
		blockExplorerUrl: "https://www.oklink.com/amoy",  
		icon: new URL(`${poly}`, import.meta.url).href,  
		testnet: true,  
		rpcUrl: {  
			https: "https://rpc-amoy.polygon.technology",  
			wss: "",  
		},  
		logo: new URL(`${poly}`, import.meta.url).href,  
		nameInCoingecko: "polygon-pos",  
		contractAddress: "0x81639AA9dc3e6046004D2270B41d9B020FAD9520",  
		onRekordCollectionAddress: "0x81639AA9dc3e6046004D2270B41d9B020FAD9520",  
		currencyTokens: {  
			// Native MATIC  
			"0x0000000000000000000000000000000000000000": {  
				id: "matic-network",  
				address: "0x0000000000000000000000000000000000000000",  
				symbol: "MATIC",  
				image: {  
					thumb: "https://assets.coingecko.com/coins/images/4713/thumb/matic-token-icon.png?1624446912",  
					small: "https://assets.coingecko.com/coins/images/4713/small/matic-token-icon.png?1624446912",  
					large: "https://assets.coingecko.com/coins/images/4713/large/matic-token-icon.png?1624446912",  
				},  
			},  
			// Example LINK token on Amoy 
			"0x326C977E6efc84E512bB9C30f76E30c160eD06FB": {  
				id: "chainlink",  
				address: "0x326C977E6efc84E512bB9C30f76E30c160eD06FB",  
				symbol: "LINK",  
				image: {  
					thumb: "https://assets.coingecko.com/coins/images/877/thumb/chainlink-new-logo.png?1547034700",  
					small: "https://assets.coingecko.com/coins/images/877/small/chainlink-new-logo.png?1547034700",  
					large: "https://assets.coingecko.com/coins/images/877/large/chainlink-new-logo.png?1547034700",  
				},  
			},  
		},  
	},  	
};

export const networks: any[] = [
//   {
//     id: 'ethereum',
//     name: mainnet.name,
//     chainId: `0x${mainnet.id.toString(16)}`,
//     chainIdDecimal: mainnet.id.toString(),
//     currency: 'ETH',
//     color: 'network-icon--ethereum',
//     icon: ether,
//     rpcUrls: mainnet.rpcUrls.default.http,
//     blockExplorerUrls: mainnet.blockExplorers?.default.url ? [mainnet.blockExplorers.default.url] : [],
//   },
  {
    id: 'sepolia',
    name: sepolia.name,
    chainId: `0x${sepolia.id.toString(16)}`,
    chainIdDecimal: sepolia.id.toString(),
    currency: 'SepoliaETH',
    color: 'network-icon--ethereum',
    icon: ether,
    rpcUrls: sepolia.rpcUrls.default.http,
    blockExplorerUrls: sepolia.blockExplorers?.default.url ? [sepolia.blockExplorers.default.url] : [],
    isTestnet: true,
  },
  {
    id: 'polygon',
    name: polygon.name,
    chainId: `0x${polygon.id.toString(16)}`,
    chainIdDecimal: polygon.id.toString(),
    currency: 'POL',
    color: 'network-icon--polygon',
    icon: poly,
    rpcUrls: polygon.rpcUrls.default.http,
    blockExplorerUrls: polygon.blockExplorers?.default.url ? [polygon.blockExplorers.default.url] : [],
    nativeCurrency: {
      name: 'POL',
      symbol: 'POL',
      decimals: 18,
    },
  },
//   {
//     id: 'amoy',
//     name: polygonAmoy.name,
//     chainId: `0x${polygonAmoy.id.toString(16)}`,
//     chainIdDecimal: polygonAmoy.id.toString(),
//     currency: 'POL',
//     color: 'network-icon--polygon',
//     icon: poly,
//     rpcUrls: polygonAmoy.rpcUrls.default.http,
//     blockExplorerUrls: polygonAmoy.blockExplorers?.default.url ? [polygonAmoy.blockExplorers.default.url] : [],
//     isTestnet: true,
//     nativeCurrency: {
//       name: 'POL',
//       symbol: 'POL',
//       decimals: 18,
//     },
//   },
//   {
//     id: 'bsc',
//     name: bsc.name,
//     chainId: `0x${bsc.id.toString(16)}`,
//     chainIdDecimal: bsc.id.toString(),
//     currency: 'BNB',
//     color: 'network-icon--bsc',
//     icon: binance,
//     rpcUrls: bsc.rpcUrls.default.http,
//     blockExplorerUrls: bsc.blockExplorers?.default.url ? [bsc.blockExplorers.default.url] : [],
//     nativeCurrency: {
//       name: 'BNB',
//       symbol: 'BNB',
//       decimals: 18,
//     },
//   },
//   {
//     id: 'bsc-testnet',
//     name: bscTestnet.name,
//     chainId: `0x${bscTestnet.id.toString(16)}`,
//     chainIdDecimal: bscTestnet.id.toString(),
//     currency: 'tBNB',
//     color: 'network-icon--bsc',
//     icon: binance,
//     rpcUrls: bscTestnet.rpcUrls.default.http,
//     blockExplorerUrls: bscTestnet.blockExplorers?.default.url ? [bscTestnet.blockExplorers.default.url] : [],
//     isTestnet: true,
//     nativeCurrency: {
//       name: 'BNB',
//       symbol: 'BNB',
//       decimals: 18,
//     },
//   },
];

export const ENABLED_NETWORKS =
OR_APP_ENV === 'qa'
	? networks.filter((n) => n.isTestnet)
	: networks.filter((n) => !n.isTestnet);

export const supportedChainIds = ENABLED_NETWORKS.map((n) => n.chainId);
